module.exports = __webpack_public_path__ + "img/news1-4.0f5c8637.png";